export abstract class Component {
    public $element!: JQuery;

    protected abstract drawElement(): JQuery;

    public renderTo($parent: JQuery) {
        this.$element.appendTo($parent);
    }

    public destroy() {
        this.$element.remove();
    }
}
